import React from 'react';

/**
 * StreetView component
 * Props:
 *   address: string (required) - The address to show the Google Street View image for
 *   width: string or number (optional) - CSS width for the image
 *   height: string or number (optional) - CSS height for the image
 */
function StreetView({ address, width = 400, height = 200 }) {
  if (!address) return null;

  // Google Street View Static API (requires API key)
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const encodedAddress = encodeURIComponent(address);
  const imageUrl = `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}&location=${encodedAddress}&key=${apiKey}`;

  return (
    <img
      src={imageUrl}
      alt={`Street View of ${address}`}
      width={width}
      height={height}
      style={{ borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
    />
  );
}

export default StreetView;
